const fmtK = (n) => {
  const v = Number(n) || 0;
  if (v >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
  if (v >= 1e3) return `${Math.round(v / 1e3)}k`;
  return String(v);
};

export default function SerieMensualBarras({ serie }) {
  const datos = (serie || []).slice(-12);
  const max = Math.max(1, ...datos.map((d) => d.ventas));
  return (
    <div className="flex items-end gap-2 h-36" data-testid="serie-mensual-barras">
      {datos.map((d) => {
        const hV = Math.max(2, Math.round((d.ventas / max) * 100));
        const hC = Math.max(1, Math.round((d.comision / max) * 100));
        return (
          <div key={d.mes} className="flex-1 flex flex-col items-center gap-1 min-w-0" title={`${d.mes}: ventas $${d.ventas.toLocaleString("es-CO")} · comisión $${d.comision.toLocaleString("es-CO")} · ${d.pedidos} pedidos`}>
            <div className="text-[10px] text-muted-foreground tabular-nums">{fmtK(d.ventas)}</div>
            <div className="w-full flex items-end gap-0.5 h-24">
              <div className="flex-1 bg-primary/80 rounded-t" style={{ height: `${hV}%` }} />
              <div className="flex-1 bg-emerald-500/70 rounded-t" style={{ height: `${hC}%` }} />
            </div>
            <div className="text-[10px] text-muted-foreground">{d.mes.slice(2).replace("-", "/")}</div>
          </div>
        );
      })}
      <div className="text-[10px] text-muted-foreground flex flex-col gap-1 pl-2 shrink-0">
        <span className="flex items-center gap-1"><i className="w-2 h-2 bg-primary/80 inline-block rounded-sm" /> Ventas</span>
        <span className="flex items-center gap-1"><i className="w-2 h-2 bg-emerald-500/70 inline-block rounded-sm" /> Comisión</span>
      </div>
    </div>
  );
}
